import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

/** 더보기 아이콘 액션 메뉴 styled — 박스/항목은 @components/ActionMenuSurface 공통 사용 */
export const ActionMenuAnchor = styled(Box)`
  position: relative;
  display: inline-flex;
  align-items: center;
`;

/** `.action-menu` */
export const ActionMenuRoot = styled(Box)`
  position: absolute;
  top: 36px;
  right: 0;
  z-index: 11;
`;
